import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withDataProvider, UPDATE } from 'react-admin';
import PropTypes from 'prop-types';
import { Button } from 'ra-ui-materialui';
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import {
  Cancel as CancelIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Mail as MailIcon,
  Edit as EditIcon,
  Undo as UndoIcon,
} from '@material-ui/icons';
import { push as reduxPush } from 'react-router-redux';

import './styles.css';

class OrderActionsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      isDialogOpen: false,
      chosenEndStatus: null,
    };
  }

  componentDidMount() {
    window.onclick = (event) => {
      const isOfferActionButton = event.target.matches('.orderActionButton');
      const isDropdownButton = event.target.closest('#offerOrderActionDropdownButton');
      if (!isOfferActionButton && !isDropdownButton) {
        const element = document.getElementById('dropdownItems');
        if (element) {
          element.style.display = 'none';
        }
      }
    };
  }

  onDialogOpen = (endStatus) => {
    this.setState({ chosenEndStatus: endStatus, isDialogOpen: true });
  };

  onDialogClose = () => {
    this.setState({ chosenEndStatus: null, isDialogOpen: false });
  };

  handleStatusChangeClick = async (sendEmail) => {
    const { chosenEndStatus: endStatus } = this.state;
    const element = document.getElementById('dropdownItems');
    element.style.display = 'none';
    if (this.state.isSubmitting) {
      return;
    }
    const { dataProvider, data } = this.props;
    this.setState({ isSubmitting: true, isDialogOpen: false });
    dataProvider(UPDATE, 'externalOfferOrders', { data: { endStatus, sendEmail }, id: data.id }, {
      onSuccess: {
        notification: { body: `Order Successfully ${endStatus.toUpperCase()}!`, level: 'info' },
        refresh: true,
        callback: () => {
          this.setState({ isSubmitting: false, chosenEndStatus: null });
        },
      },
      onError: {
        notification: { body: `Order could not be ${endStatus.toUpperCase()}!!`, level: 'warning' },
        callback: ({ error }) => {
          // eslint-disable-next-line no-console
          console.log('ERROR', error);
          this.setState({ isSubmitting: false, chosenEndStatus: null });
        },
      },
    });
  }

  handleSentEmailClick = async () => {
    const element = document.getElementById('dropdownItems');
    element.style.display = 'none';
    if (this.state.isSubmitting) {
      return;
    }
    const { dataProvider, data } = this.props;
    this.setState({ isSubmitting: true });
    dataProvider('EXTERNAL_OFFER_ORDER_SEND_STATUS_EMAIL', 'externalOfferOrders', { id: data.id }, {
      onSuccess: {
        notification: { body: 'Email Successfully Sent!', level: 'info' },
        refresh: true,
        callback: () => {
          this.setState({ isSubmitting: false });
        },
      },
      onError: {
        notification: { body: 'Email could not be sent at this time!', level: 'warning' },
        callback: ({ error }) => {
          // eslint-disable-next-line no-console
          console.log('ERROR', error);
          this.setState({ isSubmitting: false });
        },
      },
    });
  }

  handleEditOrderClick = async () => {
    const {
      push,
      basePath,
      data,
    } = this.props;
    push(`${basePath}/${data.id}/`);
  }

  render() {
    const { data } = this.props;
    const {
      isSubmitting,
      isDialogOpen,
    } = this.state;

    const undoLabels = {
      cancelled: 'Cancellation',
      approved: 'Approval',
      rejected: 'Rejection',
    };

    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Button
          variant="outlined"
          color="secondary"
          id="offerOrderActionDropdownButton"
          disabled={isSubmitting || _.isEmpty(data)}
          label="Offer Order Actions"
          className="dropdownButton"
          onClick={() => {
            const element = document.getElementById('dropdownItems');
            const { display } = element.style;
            element.style.display = display === 'none' ? 'block' : 'none';
          }}
        >
          { isSubmitting ? <CircularProgress style={{ width: '1em', height: '1em' }} /> : <KeyboardArrowDownIcon /> }
        </Button>
        <div
          id="dropdownItems"
          style={{
            display: 'none',
            position: 'absolute',
            overflow: 'auto',
            zIndex: 1,
            width: 240,
            marginLeft: -40,
            marginTop: 4,
            borderRadius: 4,
          }}
        >
          {_.isEmpty(data.endStatus) &&
          <Button
            variant="contained"
            label="Approve Order"
            onClick={() => this.onDialogOpen('approved')}
            style={{ width: '100%' }}
            className="successButton orderActionButton"
          >
            <ThumbUpIcon />
          </Button>}
          {_.isEmpty(data.endStatus) &&
          <Button
            variant="contained"
            label="Reject Order"
            onClick={() => this.onDialogOpen('rejected')}
            style={{ width: '100%', marginTop: 4 }}
            className="errorButton orderActionButton"
          >
            <ThumbDownIcon />
          </Button>
          }
          {_.isEmpty(data.endStatus) &&
          <Button
            variant="contained"
            label="Cancel Order"
            onClick={() => this.onDialogOpen('cancelled')}
            style={{ width: '100%', marginTop: 4 }}
            className="primaryButton orderActionButton"
          >
            <CancelIcon />
          </Button>
          }
          {!_.isEmpty(data.endStatus) &&
          <Button
            variant="contained"
            label={`Undo ${undoLabels[data.endStatus]}`}
            style={{ width: '100%', marginTop: 4 }}
            className="primaryButton orderActionButton"
            onClick={() => this.onDialogOpen('undo')}
          >
            <UndoIcon />
          </Button>
          }
          {!_.isEmpty(data.endStatus) && !data.isEndStatusChangeEmailSent &&
          <Button
            variant="contained"
            label="Send Order Status Email"
            style={{ width: '100%', marginTop: 4 }}
            className="primaryButton orderActionButton"
            onClick={this.handleSentEmailClick}
          >
            <MailIcon />
          </Button>
          }
          <Button
            variant="contained"
            label="Edit Offer Order"
            style={{ width: '100%', marginTop: 4 }}
            className="blueGray orderActionButton"
            onClick={this.handleEditOrderClick}
          >
            <EditIcon />
          </Button>
        </div>
        <Dialog
          open={isDialogOpen}
          onClose={this.onDialogClose}
        >
          <DialogTitle id="alert-dialog-title">
            {'Send email for status change?'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you want to sent the email depicting this status change immediately after your action resolves?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="default"
              onClick={() => this.handleStatusChangeClick(true)}
              label="Yes"
              style={{ paddingRight: 15 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.handleStatusChangeClick(false)}
              label="No"
              style={{ paddingRight: 15 }}
            />
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

OrderActionsDropdown.propTypes = {
  data: PropTypes.shape({}),
};

OrderActionsDropdown.defaultProps = {
  data: {},
};

const mapStateToProps = state => ({ isRouterLoading: state.admin.loading, resourceData: state.admin.resources.externalOfferOrders.data });

export default connect(mapStateToProps, { push: reduxPush })(withDataProvider(OrderActionsDropdown));




// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/OrderActionsDropdown.js